import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/app/loader.service';

const SKIP_URL_FRAGMENTS = [
  'exception-log',
  'authenticate',
  'blog-login',
  'portal-login',
  'company-login',
  'select-company',
  'financial-year',
  'searchparties',
  'send-otp',
  'verify-otp',
  'validate-otp',
  'otp-and-email',
  'password-from',
  'subscriber-data',
  'subscriber-details',
  'companyaccess',
  'check-tax',
  'leave-types',
  'leave-type',
  'branch/branch',
  'employee-status/employee-status',
  'employee-type/employee-type',
  'hiring-source/hiring-source',
  'stream/stream',
  'all-guests',
  'all-companies',
  'by-id',
  'states-for-new-company',
  'activity-log',
  'generate-ref-no',
  'payment-data-for-subscription',
  'salary-components',
  '/report/',
  'reports/',
  '/api/status',
  '/api/start',
  '/api/logout',
  'pdf-invoice',
  'contact-details',
  'email-record',
  'send-sms',
  'send-message',
  'send-media',
];

@Injectable()
export class FormSaveLoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.shouldShowLoader(request)) {
      return next.handle(request);
    }

    this.loaderService.show('Saving data, please wait...');
    return next.handle(request).pipe(
      finalize(() => this.loaderService.hide())
    );
  }

  private shouldShowLoader(request: HttpRequest<unknown>): boolean {
    const method = request.method.toUpperCase();
    if (method !== 'POST' && method !== 'PUT') {
      return false;
    }

    const url = request.url.toLowerCase();
    return !SKIP_URL_FRAGMENTS.some((fragment) => url.includes(fragment));
  }
}
